module.exports = __webpack_public_path__ + "static/img/s1.d9938857.png";